import { formatDate } from '@niaratech/niara-js-commons';
import { addDays } from '@niaratech/niara-js-commons/dist/dateUtils';
const formatPenaltyDate = (penaltyDate: string, locale?: string | undefined): string => {
  if (!penaltyDate) return '';
  if (penaltyDate.length == 10) {
    /* não tenho precisamente o horário da data de cancelamento */
    return formatDate(addDays(penaltyDate, -1), locale);
  } else {
    const penaltyFreeDate = addDays(penaltyDate, -1 / (24 * 60));
    // se a penalidade começa à meia noite, trunca a data para não aparecer "XX/XX/2025 23:59"
    if (formatDate(penaltyFreeDate, 'pt-BR', 'HH:mm') == '23:59') {
      return formatDate(addDays(penaltyDate.substring(0, 10), -1), locale);
    } else {
      return formatDate(penaltyFreeDate, locale);
    }
  }
};
export default formatPenaltyDate;
export const shouldShowTimezoneMessage = (penaltyDate: string, inPenalty: boolean | string): boolean => {
  const penaltyFreeDate = addDays(penaltyDate, -1 / (24 * 60));
  return formatDate(penaltyFreeDate, 'pt-BR', 'HH:mm') != '23:59' && !inPenalty;
};